<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <p class="t-left font-S14 fontC-4fa1a4 mb20" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p>
      <el-row :gutter="24">
        <el-col :span="7"
          ><div class="search-area-div">运营单元：</div>
          <el-input v-model="page.operationUnitName" class="ipt-sty" placeholder="请输入核算单元"></el-input
        ></el-col>

        <el-col :span="8">
          <div>
            <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty">清空</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addBizUnit">新增运营单元</el-button>
      <span style="margin-left: 20px; font-size: 14px">提示：用于区分运营人员的数据权限而设定的运营单元</span>
      <div class="fr line-h40 h40 font-S16 mr16">{{tenantName}}，有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个运营单元</div>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%"  :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>  
        <el-table-column prop="operationUnitName" label="运营单元" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.operationUnitName }}</template>
        </el-table-column>
        <el-table-column
          prop="createUserName"
          label="创建人"
          header-align="center"
          align="center" 
        ></el-table-column> 
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="150px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editUnit(scope.row)">编辑 | </a>
            <a class="txt-color" @click="checkUnit(scope.row.guid)">删除 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible1" width="40%">
      <el-form>
        <el-form-item label="*运营单元名称:">
          <el-input  class="ipt-sty fl" type="text" placeholder="请输入核算单元名称" v-model="operationUnitName"> </el-input>
        </el-form-item>
        <el-form-item label="　*药企方名称:">
          <!-- <el-input v-model="tenantName" autocomplete="off" style="width: 300px" :disabled="true"></el-input> -->
          <el-select v-model="tenantGuid" filterable placeholder="请选择" class="ipt-sty fl" @change="getOrgUnitRegion">
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="　*按组织设定:"> 
          <el-tree class="filter-tree ipt-sty fl" :data="areaData" :props="defaultProps" :show-checkbox="true" node-key="id" :filter-node-method="filterNodeDep" @node-click="handleNodeClick1" ref="treeDep"
            :default-checked-keys="departList" @check-change="checkChange">
            <div class="custom-tree-node" slot-scope="{ node,data }">
              <img :src="data.icon" alt="" style="width:18px;height:18px;">
              <span>{{ data.label }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span>
            </div>
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增运营单元'"
          @click="addBizUnitInterface"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateBizUnitInterface"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增运营单元',
      dialogVisible1: false,
      tableData:[],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid:'',
        operationUnitName: '',
      },
      tenantGuid:'',
      operationUnitGuid:'',
      operationUnitName: '',
      tenantGuid: '',
      tenantName: this.$route.query.tenantName,
      dialogVisible1: false,
      rowGuid: '',
      height: window.innerHeight - 360,
      tenantList:[],
      areaData:[],
      defaultProps: {
        id: 'id',
        label: 'label',
        children: 'children',
      },
      departmentData: [],
      departList: [],
    };
  },
  created() {
    // 列表
    this.getData();
    this.getTenantOperationRelList();
  },
  watch: {},
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: self.$route.query.tenantGuid,
        operationUnitName: '', 
      };
      self.getData(true);
    },
    checkChange(val) {
      this.departmentList = [];
      let checkNodes = this.$refs.treeDep.getCheckedNodes();
      if(checkNodes.length > 0){
        checkNodes.forEach((i)=>{
          if(i.org == 1 || i.org == 2){
            this.departmentList.push(i);
          }
        })
      }
      // this.departmentList = this.$refs.treeDep.getCheckedNodes(); 
      console.log('11',this.departmentList);
    }, 
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data); 
      console.log(self.departmentList);
    },
    getOrgUnitRegion(){
      let self = this;    
      self.api.get(`/${serverConfig.msPersonnelService}/organisation/data/get-org-unit-region?tenantGuid=`+self.$store.getters.getTenantGuid+'&bizState=Y'+'&sendTenantGuid='+self.tenantGuid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
          self.treeData(self.areaData);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    treeData(areaData) {
        var self = this;
        // const treeData = [];
        // const getPerson = () => {};
        const fn = (tree) => {
          tree.forEach(async (k) => {
            k.org = 1;
            k.label = k.organisationName;
            k.id = k.guid;
            k.icon = require("../../assets/images/ico_ora.png")
            // 根据id获取区域数据,(注意转为树类型)
            if (k) {
              // const person = await self.getStaff(k.guid);
              k.territoryLists = [];
              if(k.territoryList){
                k.territoryList.forEach((d)=>{
                  let item = {
                    org:2,
                    id:d.guid,
                    label:d.territoryName,
                    icon:require("../../assets/images/icon_quyu.png")
                  }
                  k.territoryLists.push(item);
                })
              }
              const person = k.territoryLists;
              const isValid = (val) => {
                return val && val !== null && JSON.stringify(val) !== '[]';
              };
              // 将区域数据拼接到chilren里面
              if (k.children) {
                fn(k.children);
                isValid(person) && (k.children = [...k.children, ...person]);
                // 有子元素，需要调用自身
              } else {
                isValid(person) && (k.children = person);
              }
            }
          });
        };
        fn(areaData);
        console.log(areaData);
      }, 
    //运营获取药企
    getTenantOperationRelList(){
      let self = this;  
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`,{'tenantGuid':self.$store.getters.getTenantGuid,'isService':true}).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.page.tenantGuid = self.$route.query.tenantGuid;
      let pormsie = {
        operationUnitName:self.page.operationUnitName,
        pageIndex:self.page.pageIndex,
        pageSize:self.page.pageSize,
        tenantGuid:self.page.tenantGuid
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/operationunit/data/get`,pormsie).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = [];
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //新增核算单元
    addBizUnit() {
      this.textTitle = '新增运营单元';
      this.tenantGuid = '';
      this.operationUnitName = '';
      this.areaData = [];
      this.departList = []; 
      this.defaultProps = [];
      this.departmentList = [];
      this.$nextTick(() => {
          this.$refs.treeDep.setCheckedNodes(this.departmentList);
      }); 
      this.dialogVisible1 = true;
    },
    //确定
    addBizUnitInterface() {
      var self = this;
      if (!this.operationUnitName) {
        self.$message.error('运营单元名称不能为空');
        return;
      }
      if (!this.operationUnitName) {
        self.$message.error('药企方名称不能为空');
        return;
      }
      let ouoList = [];
      if(this.departmentList != null && this.departmentList.length > 0){
        this.departmentList.forEach((i)=>{
          let organisationGuid = null;
          let salesTerritoryGuid = null;
          if(i.org == 1){
            organisationGuid = i.id;
          }else{
            salesTerritoryGuid = i.id;
          }
          let item = {
            sendTenantGuid:self.tenantGuid,
            organisationGuid:organisationGuid,
            salesTerritoryGuid:salesTerritoryGuid
          }
          ouoList.push(item);
        })
      }else{
        self.$message.error('请选择部门或区域!');
        return;
      }
      var query = {
        tenantGuid:self.$store.getters.getTenantGuid,
        operationUnitName: self.operationUnitName,
        ouoList:ouoList
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/operationunit/data/add`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE||res.data == '') {
          self.$message.success('新增成功');
          self.dialogVisible1 = false;
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    editUnit(row) {
      let self = this;
      self.textTitle = '编辑运营单元'; 
      self.guid = row.guid; 
      self.operationUnitGuid = row.guid;
      self.operationUnitName = row.operationUnitName;
      self.departList = [];
      self.departmentList = [];
      if(row.ouoList != null && row.ouoList.length >0){
        self.tenantGuid = row.ouoList[0].sendTenantGuid; 
        row.ouoList.forEach((i)=>{
          if(i.organisationGuid){
            self.departList.push(i.organisationGuid);
            // this.departmentList.push(i.organisationGuid);
          }else if(i.salesTerritoryGuid){
            self.departList.push(i.salesTerritoryGuid); 
          }
        })
        console.log('3333',self.departList);
      }
      self.getOrgUnitRegion();
      setTimeout(function(){
        self.checkChange();
      },1000) 
      self.dialogVisible1 = true; 
    },
    //修改
    updateBizUnitInterface() {
      var self = this;
     if (!this.operationUnitName) {
        self.$message.error('运营单元名称不能为空');
        return;
      }
      if (!this.operationUnitName) {
        self.$message.error('药企方名称不能为空');
        return;
      }
      let ouoList = [];
      if(this.departmentList != null && this.departmentList.length > 0){
        this.departmentList.forEach((i)=>{
          let organisationGuid = null;
          let salesTerritoryGuid = null;
          if(i.org == 1){
            organisationGuid = i.id;
          }else{
            salesTerritoryGuid = i.id;
          }
          let item = {
            sendTenantGuid:self.tenantGuid,
            organisationGuid:organisationGuid,
            salesTerritoryGuid:salesTerritoryGuid
          }
          ouoList.push(item);
        })
      }else{
        self.$message.error('请选择部门或区域!');
        return;
      }
      var query = {
        guid:self.operationUnitGuid,
        tenantGuid: self.$store.getters.getTenantGuid,
        operationUnitName: self.operationUnitName,
        ouoList:ouoList
      };
      self.fullscreenLoading = true; 
      self.api.put(`/${serverConfig.msPersonnelService}/operationunit/data/update`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE||res.data == '') {
          self.$message.success('修改成功');
          self.dialogVisible1 = false;
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //删除单元
    checkUnit(guid){
      var self = this;
      self.fullscreenLoading = true;
      let guids = []; 
      guids.push(guid);
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/operationunit/data/delete`,guids)
        .then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error('删除运营单元成功!');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
/deep/ .el-form-item__content {
    line-height: 30px;
    position: relative;
    font-size: 14px;
    margin-left: 105px;
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>